import type { IModuleRepository } from "@/application/ports/repositories";
import type { ModuleEntitlement } from "@/domain/modules";
import * as sdk from "../generated/sdk.gen";
import { unwrap } from "../unwrap";

export class ModuleRepository implements IModuleRepository {
  async getEntitlements(): Promise<ModuleEntitlement[]> {
    const response = await unwrap(sdk.getOrgEntitlements());
    return response.items;
  }
}
